import { Link } from "react-router-dom";
import { ArrowRight, Coins } from "lucide-react";
import { Reveal } from "./Reveal";

// Dwa kafle „NOWOŚĆ" pod hero (grafiki 16:9 z dev packa). Teksty w HTML (dostępność/SEO).
const CARDS = [
  {
    key: "cv",
    to: "/cv",
    img: "/assets/nowosci/promptivo-cv-feature.svg",
    alt: "Podgląd CV, wskaźnika dopasowania do oferty i listy potencjalnych pracodawców.",
    title: "CV gotowe na współczesną rekrutację",
    desc: "Stwórz CV od zera lub popraw obecne. Dopasuj je do konkretnej oferty, sprawdź zgodność z wymaganiami i przygotuj dokument czytelny dla systemów ATS oraz rekrutera. Znajdź też firmy, do których warto aplikować.",
    cta: "Stwórz lub sprawdź CV",
  },
  {
    key: "business",
    to: "/biznes/generator",
    img: "/assets/nowosci/promptivo-business-feature.svg",
    alt: "Trzy pomysły biznesowe ze scoringiem i siedmiodniowym planem walidacji.",
    title: "Znajdź pomysł na biznes dopasowany do Ciebie",
    desc: "Odpowiedz na kilka pytań, a Promptivo wygeneruje 3 realne kierunki dopasowane do Twoich umiejętności, budżetu i czasu — ze scoringiem oraz planem pierwszych działań.",
    cta: "Wygeneruj pomysły",
  },
];

export const NewFeaturesSection = () => (
  <section
    className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-[88px]"
    data-testid="new-features-section"
    aria-label="Nowe usługi Promptivo"
  >
    <div className="grid grid-cols-1 items-stretch gap-6 md:grid-cols-2">
      {CARDS.map((c, i) => (
        <Reveal key={c.key} delay={i * 0.1} className="h-full">
          <Link
            to={c.to}
            data-testid={`new-feature-${c.key}`}
            className="group flex h-full flex-col overflow-hidden rounded-panel border border-brand-accent/25 bg-brand-surface shadow-[0_1px_0_rgba(255,255,255,0.04)_inset] outline-none transition-[transform,border-color,box-shadow] duration-200 hover:-translate-y-1 hover:border-brand-accent/70 hover:shadow-[0_18px_48px_-24px_rgba(190,242,100,0.35)] focus-visible:border-brand-accent focus-visible:ring-2 focus-visible:ring-brand-accent/60"
          >
            <div className="relative aspect-[16/9] overflow-hidden bg-brand-bg">
              <img
                src={c.img}
                alt={c.alt}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover object-center"
              />
              <span className="absolute left-4 top-4 inline-flex items-center rounded-full bg-brand-accent px-3 py-1 text-[12px] font-extrabold uppercase tracking-[0.16em] text-brand-on shadow-sm">
                Nowość
              </span>
            </div>
            <div className="flex flex-1 flex-col gap-3 p-6 md:p-8">
              <h2 className="font-display text-[26px] font-bold leading-tight text-brand-text md:text-[32px]">
                {c.title}
              </h2>
              <p className="text-[15px] leading-relaxed text-brand-sec">{c.desc}</p>
              <span
                data-testid={`new-feature-${c.key}-cta`}
                className="mt-auto inline-flex h-12 w-full items-center justify-center gap-2 rounded-button bg-brand-accent px-6 text-[15px] font-semibold text-brand-on transition-transform duration-200 group-hover:-translate-y-0.5"
              >
                {c.cta}
                <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        </Reveal>
      ))}
    </div>

    {/* Jasna informacja o kredytach — bez obietnicy „bezpłatnie" dla operacji AI */}
    <Reveal delay={0.2}>
      <div
        data-testid="new-features-credits-note"
        className="mt-6 flex items-start gap-3 rounded-panel border border-brand-line bg-brand-surface/60 px-5 py-4 text-[13px] leading-relaxed text-brand-sec md:text-sm"
      >
        <Coins size={18} className="mt-0.5 shrink-0 text-brand-accent" aria-hidden="true" />
        <p>
          Wypełnienie formularza i zapis projektu są bezpłatne. Przed uruchomieniem funkcji AI zobaczysz dokładny
          koszt w kredytach. Kredyty zostaną pobrane tylko po poprawnym zakończeniu operacji.
        </p>
      </div>
    </Reveal>
  </section>
);
